module.exports = __webpack_public_path__ + "img/login_bg.c7a06bdb.png";